import { connect } from 'react-redux';

import NewBook from '../components/NewBook';
import { openDialog } from '../redux/alert';

import { loadData, loadUser } from '../redux/data';
import {
  checkPreferences,
  handleStartTimeFilter,
  handleParkinglotFilter,
  handleTierFilter,
  handleChangeDate,
  handleDurationFilter,
  loadAvailableShifts,
  newPreferences,
  toggleShiftList,
  searchAvailableShifts,
  removeFromSelectedShifts,
  clearSelectedShifts,
} from '../redux/book';

const mapStateToProps = ({ auth, alert, data, book, dashboard, calendar }) => ({
  ...auth,
  ...alert,
  ...data,
  ...book,
  ...calendar,
  ...dashboard,
});

const mapDispatchToProps = dispatch => ({
  clearSelectedShifts: () => dispatch(clearSelectedShifts()),
  loadAvailableShifts: availableShifts => dispatch(loadAvailableShifts(availableShifts)),
  checkPreferences: () => dispatch(checkPreferences()),
  toggleShiftList: (shift, selected) => dispatch(toggleShiftList(shift, selected)),
  loadData: () => dispatch(loadData()),
  handleStartTimeFilter: shift => dispatch(handleStartTimeFilter(shift)),
  handleChangeDate: (startDate, endDate) => dispatch(handleChangeDate(startDate, endDate)),
  newPreferences: body => dispatch(newPreferences(body)),
  searchAvailableShifts: shift => dispatch(searchAvailableShifts(shift)),
  handleDurationFilter: duration => dispatch(handleDurationFilter(duration)),
  handleTierFilter: tier => dispatch(handleTierFilter(tier)),
  handleParkinglotFilter: (parkinglot, isInputChecked) => dispatch(handleParkinglotFilter(parkinglot, isInputChecked)),
  loadUser: () => dispatch(loadUser()),
  removeFromSelectedShifts: shift => dispatch(removeFromSelectedShifts(shift)),
  openDialog: (type, dialogMessages) => dispatch(openDialog(type, dialogMessages)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewBook);



// WEBPACK FOOTER //
// ./src/containers/NewBook.js